import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Logo from "../components/common/logo";
import EducationExperience from "../components/education/educationExperience.jsx";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/education.css";

const Education = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "education") || {
		description: "My educational background and academic achievements.",
		keywords: ["Education", "University", "Academic", "Degree"]
	};

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Education | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="education" />
				<div className="content-wrapper">
					<div className="education-logo-container">
						<div className="education-logo">
							<Logo width={40} />
						</div>
					</div>
					<div className="education-container">
						<div className="title education-title">
							My Academic Journey
						</div>

						<div className="subtitle education-subtitle">
							Here's a timeline of my education background.
						</div>

						<div className="education-experience-list">
							<EducationExperience />
						</div>
					</div>

					<div className="page-footer">
						<div className="copyright">
							{INFO.copyright}
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Education;